<template>
  <fb-form-body>
    <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="fb-form">
      <el-form-item :label="$t('lang.账户') + '：'" prop="account">
        <el-input v-model="$store.state.userInfo['account']" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('lang.原密码') + '：'" prop="oldPassword">
        <el-input v-model="formData.oldPassword"></el-input>
      </el-form-item>
      <el-form-item :label="$t('lang.新密码') + '：'" prop="newPassword">
        <el-input v-model="formData.newPassword"></el-input>
      </el-form-item>
      <el-form-item :label="$t('lang.再次输入新密码') + '：'" prop="rePassword">
        <el-input v-model="formData.rePassword"></el-input>
      </el-form-item>


      <el-form-item>
        <el-button type="primary" @click="handleSubmit('form')">{{ $t('lang.保存') }}</el-button>
        <el-button @click="handleReset('form')">{{ $t('lang.重置') }}</el-button>
      </el-form-item>
    </el-form>
  </fb-form-body>
</template>

<script>

export default {
  name: "EditPassword",
  components: {},
  data() {

    return {
      api: {
        update: this.$api.email.updatePassword,
      },
      formErrorMsg: {name: ''},
      formData: {
        oldPassword: '',
        newPassword: '',
        rePassword: ''
      },
    }
  },
  computed: {
    rules() {
      let checkRePassword = (rule, value, callback) => {
        if (value != this.formData.newPassword) {
          return callback(new Error(this.$t('lang.两次输入密码不相同，请重新输入')));
        }
        callback();
      };
      return {
        oldPassword: [
          {required: true, message: this.$t('lang.密码不能为空'), trigger: 'blur'},
          { min: 8, message: this.$t('lang.密码需以数字字母组成，并不能少于8位'), trigger: 'blur' },
        ],
        newPassword: [
          {required: true, message: this.$t('lang.密码不能为空'), trigger: 'blur'},
          { min: 8, message: this.$t('lang.密码需以数字字母组成，并不能少于8位'), trigger: 'blur' },
        ],
        rePassword: [
          {required: true, message: this.$t('lang.密码不能为空'), trigger: 'blur'},
          { min: 8, message: this.$t('lang.密码需以数字字母组成，并不能少于8位'), trigger: 'blur' },
          { validator: checkRePassword, trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    handleSubmit(form) {
      let vm = this;
      vm.$refs[form].validate((valid) => {
        if (valid) {
          let {oldPassword, rePassword} = vm.formData;
          const data = {
            oldPassword: vm.$md5(oldPassword),
            password: vm.$md5(rePassword),
            code: vm.$store.state.userInfo.code,
          }

          vm.$http.post(vm.api.update,this.$qs.stringify(data)).then((resp) => {
            if (resp.data.status === 200) {
              vm.$message({
                type: 'success',
                message: resp.data.desc
              });
              vm.$router.push('/login');
              window.localStorage.clear();
              window.sessionStorage.clear();
            } else if (resp.data.status === 400) {
              resp.data.data.errorFields.forEach(function (a) {

                vm.formErrorMsg[a.name] = '';
                vm.$nextTick(() => {
                  vm.formErrorMsg[a.name] = a.message;
                });

              });
              vm.$message({
                type: "error",
                message: resp.data.desc
              });
            } else {
              vm.$message({
                type: "error",
                message: resp.data.desc
              })
            }

          });
          return true;
        } else {
          return false;
        }
      });

    },
    handleReset(form) {
      this.$refs[form].resetFields();
    }
  },

  created() {
  }
}
</script>

<style lang="scss" scoped>

.fb-form {
  max-width: 500px;
}
</style>
